// pages/ResetPassword.jsx
import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api/axios";
import "../styles/Auth.css";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const uid = searchParams.get("uid");
  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== password2) {
      setError("Las contraseñas no coinciden.");
      return;
    }
    if (password.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/password-reset-confirm/", { uid, token, password });
      setMsg("¡Contraseña actualizada! Ya puedes iniciar sesión.");
      setTimeout(() => navigate("/sesion"), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || "Enlace inválido o caducado.");
    } finally {
      setLoading(false);
    }
  };

  if (!uid || !token) {
    return (
      <div className="auth">
        <div className="auth__card">
          <h2>Enlace inválido</h2>
          <p>Este enlace no es válido. Solicita uno nuevo desde la página de inicio de sesión.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth">
      <div className="auth__card">
        <h2>Nueva contraseña</h2>
        <p className="auth__muted">Elige una contraseña segura de al menos 8 caracteres.</p>

        {msg && <div style={{ color: "green", marginBottom: 16 }}>{msg}</div>}
        {error && <div className="auth__error">{error}</div>}

        {!msg && (
          <form onSubmit={onSubmit} className="auth__form">
            <label>
              Nueva contraseña
              <input type="password" value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" required />
            </label>
            <label>
              Repetir contraseña
              <input type="password" value={password2}
                onChange={(e) => setPassword2(e.target.value)}
                placeholder="••••••••" required />
            </label>
            <button className="auth__primary" type="submit" disabled={loading}>
              {loading ? "Guardando..." : "Guardar contraseña"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}